export default class AutocompleteModel {
    name!: string;
    id!: number;
    providedByPTH!:boolean;
    type?:string;
  }
  